import React, { FC } from 'react';
import PaginationWrapper from '@common/PaginationWrapper';
import { useAppSelector } from '@hooks/redux';
import { useLocation, useSearchParams } from 'react-router-dom';
import { getParamsFromSearch } from '@app/utils/utils';
import styles from '../EnvelopesTable.module.scss';
import cn from 'classnames';
import { Instance } from '@app/const/consts';
import { useTranslation } from 'react-i18next';

const EnvelopesPagination: FC = () => {
  const { data } = useAppSelector(state => state.envelopes.envelopes)
  const pagination = useAppSelector(state => state.pagination)
  const [ , setSearchParams ] = useSearchParams()
  const { pathname } = useLocation()
  const instanceRU = useAppSelector((state) => state.utils.instance) === Instance.RU;
  const { t } = useTranslation();

  if (!pagination) return null

  const isDisabled =
    pagination.nextPage === null &&
    pagination.pageIndex === 1

  const handleChangePage = (pageIndex: number | string): void => {
    const params = getParamsFromSearch(location.search);
    params['page']= pageIndex;

    const itemPerPage = localStorage.getItem(pathname)
    itemPerPage && (params['perPage'] = itemPerPage)

    setSearchParams(params)
  }

  return (
    <div>
      {instanceRU && (
        <div className={cn(styles.rules, 'text-muted')}>
          {/* eslint-disable-next-line no-irregular-whitespace */}
          {t('common:rules1')}
          <a
            href='/assets/docs/Правила_платформы_greenDocs.pdf'
            className={cn(styles.rules__link, 'text-muted')}
            target='_blank'
            rel="noopener noreferrer"
          >
            {t('common:rules2')}
          </a>
          .
        </div>
      )}
      <PaginationWrapper
        changePage={handleChangePage}
        pagination={pagination}
        itemsInPage={data.length}
        isDisabled={isDisabled}
      />
    </div>
  );
}

export default EnvelopesPagination
